var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tileDetail"},[_c('div',{staticClass:"tileName"},[(_vm.$route.params.tilesOrConstructions === 'tile')?_c('div',[_c('content-title',[_vm._v("タイル詳細")]),_vm._v(" "),_c('detail-tile',{attrs:{"tile-id":_vm.$route.params.id}})],1):_c('div',[_c('detail-construction',{attrs:{"construction-id":_vm.$route.params.id}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f7f5ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail.vue
// module id = null
// module chunks = 